import { ContactlessOutlined } from "@material-ui/icons";
// import { AsyncMode } from "react-resize-panel";
import { apiGet, apiPost, apiPut } from "./apiUtils";
import {  getLoggedInUserTenantID } from "./sessionUtil";



export function updateBot(bot){
    
    // let i = bots.findIndex((b)=>b.botID === bot.botID);
    // bots[i] = {...bot};
}
const waitFor = (milliseconds) =>{
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export function createBot(botName){
    const data = {}
    data.version = 'v1'
    data.tenantId = getLoggedInUserTenantID()
    data.botName = botName
    
    let url = `${process.env.REACT_APP_API_PREFIX}/bot/createBotFromScratch`;
    return apiPost(url,data);
}




export async function saveBotToLibrary(botName,setShowProgress,setProgress,progress,setUploadStatus){

    console.log("Create Bot to get bot ID")
    var fileMap = new Map();
  
    setProgress(0);
    setShowProgress(true);
    setUploadStatus("In Progress");
    createBot(botName).then(response=> {
        if(!response.ok){
            throw new Error("HTTP error, status = " + response.status);
        }
        setProgress(10)
        return response.json();
    })
    .then(json=> {
        console.log("Create Bot succesfull");
        console.log(json.data.botId);
        console.log(json.result);
        console.log(json.message);
      
        console.log("Getting bot file list")
        let url = `http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/images/list/${botName}`
        console.log(`get images for bot ${url}`)
        apiGet(url).then(csvfileList =>{  
            
            if(csvfileList == null)
                throw new Error(`File list for bot ${botName} is empty`);  
            
            setProgress(20)
            let completeFileList = `${csvfileList},${botName}.rec,apps.json,map.json,transform.json`
            console.log(`bots file list :${completeFileList}`)
            
            let fileList = completeFileList.split(",");
            console.log("For each file get File Contents")
            fileList.forEach(file => {
                // /v1/enterprise/{recordingName}/files/{name}
                let getFileContentUrl = `http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/${botName}/files/${file}`;
                console.log(`Get File Contents for ${getFileContentUrl}`)
                apiGet(getFileContentUrl).then(fileContents =>{
                    fileMap.set(file,fileContents);
                })
            })
            setProgress(50)
            console.log(`Done getting file Contents for ${completeFileList}`)
            return completeFileList;
        }).then(fileList => {
            console.log(`generate Upload PresignedUrl List for BotId: ${json.data.botId} bot Name: ${botName}`)

            let url = `${process.env.REACT_APP_API_PREFIX}/storagemanagement/generateUploadPresignedUrlListByBotId`

            let data = {}
            data.botId = json.data.botId
            data.fileNameDelimitedList = fileList
            
            console.log(`calling ${url} with ${data} `)
            apiPost(url,data).then(res=>{
                if(!res.ok){
                    throw new Error("HTTP error, status = " + res.status);
                }
                setProgress(60)
                console.log("Done getting presigned Upload url")
                return res.json()
            })
            .then(json=>{
                console.log(`Response from ${url} : ${JSON.stringify(json)}`)
                let preSignedURLList = json.data.preSignedUrList;
                let index = 0;
                preSignedURLList.forEach((preSignedURL)=>{
                    index = index + 1;
                    let numfiles = fileMap.size;
                    apiPut(preSignedURL.url,fileMap.get(preSignedURL.fileName),preSignedURL.contentType)
                    .then(res=> {
                        console.log(`Response from uploading file ${preSignedURL.fileName} is ${res}`)
                        
                        setProgress(progress + (index/numfiles)*40)
                    })
                    setUploadStatus("Completed!");

                })

            })
        })
        waitFor(2000).then(() => {
            setShowProgress(false);
        });

    }).catch(err =>{
        console.log(`Save bot to library failed ${err.message}`)
        setShowProgress(false);
        throw new Error("server error while saving bot to library");
    })
   

}

export function getBotListFromLibrary(){
    let url = `${process.env.REACT_APP_API_PREFIX}/bot/getBotsByTenantId/${getLoggedInUserTenantID()}`
    // console.log(`Calling ${url}`);
    return apiGet(url)
    .then(json=>{
   
        // console.log(`Response result : ${json.result}`);
        console.log(`Bots data : ${json.data}`);

        // json.data.forEach(bot =>{
        //     for(let [key,value] of Object.entries(bot)){
        //         console.log(`key: ${key} value:${value}`)
        //     }
        //     console.log("")
        // })
        

        return json.data;        

    }).catch(err=> {
        console.log(`Error during getBotListFromLibrary ${err.message}`)
        throw new Error("Error duing getBotListFromLibrary");
    })

}


export function setupBotSchedule(botSchedules,env,setScheduleStatus){
    let url = `${process.env.REACT_APP_API_PREFIX}/botschedule/createBotSchedule`

    botSchedules.forEach(schedule => {
        let botSchedule = {
            tenantId: getLoggedInUserTenantID(),
            environment:schedule.env,
            botName: schedule.botName,
            scheduleName:schedule.scheduleName,
            timezone:schedule.timezone,
            startTimeExecutionRange:schedule.startTime,
            endTimeExecutionRange:schedule.endTime
        }

    });
}



export function setupBotDeploymentConfig(botAgentsMap,env,setDeployStatus){
    let url = `${process.env.REACT_APP_API_PREFIX}/deployment/createBotExecutionConfig`
    let deploymentProfile = {
        ExecutionProfile : {
            tenantId: getLoggedInUserTenantID(),
            environment:env,
            BotAgentLinkList: botAgentsMap
        }
        
    }
  
    


    return apiPost(url,deploymentProfile).then(res => {
        if(res.ok){
            // setAgentsChangedTrigger(true);
            setDeployStatus("Successfully Added new Items to the Deployment Profile")
            setTimeout(() => {
                setDeployStatus("");
            },3000);
            return res.json()

        }else{
            console.log("Response is not ok during apiPost deployBots. thowing exception")
            throw new Error("Response is not ok during apiPost deployBots.")
        }
    })
    .then((json)=>{
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    .catch(err => {
        console.log(`Error during deployBots ${err.message}`)
        throw new Error("Server error during deployBots");
    })
    

}


export function getBotDeploymentConfigByEnv(env){
    let url = `${process.env.REACT_APP_API_PREFIX}/deployment/getBotExecutionConfigsByTenantIdAndEnvironment/tenant/${getLoggedInUserTenantID()}/environment/${env}`;
    return apiGet(url).then((json)=>{

        // console.log(`Response result : ${json.result}`);
        // console.log(`Response data length: ${json.data.length}`);
        // console.log(`Response data length: ${JSON.stringify(json.data)}`);
        return json.data;
    }).catch(err => {
        console.log(`Error during getBotDeploymentConfigByEnv ${err.message}`);
        // Commenting out to allow local bots
        // throw new Error("Error during getBotDeploymentConfigByEnv");
    })

}


export function getBotSchedulesByEnv(env){
    let url = `${process.env.REACT_APP_API_PREFIX}/botschedule/getBotSchedulesByTenantId/${getLoggedInUserTenantID()}}`;
    return apiGet(url).then((json)=>{

        // console.log(`Response result : ${json.result}`);
        // console.log(`Response data length: ${json.data.length}`);
        // console.log(`Response data length: ${JSON.stringify(json.data)}`);
        console.log (json.data)
        return json.data;
    }).catch(err => {
        console.log(`Error during getBotSchedulesByEnv ${err}`);
        // throw new Error(err);
    })

}

export function getBotExceptionsByEnv(env){
    
    let url = `${process.env.REACT_APP_API_PREFIX}/bot/getBotExceptionsByTenantIdAndEnvironment/tenant/${getLoggedInUserTenantID()}/environment/${env}}`;
    return apiGet(url).then((json)=>{

        // console.log(`Response result : ${json.result}`);
        // console.log(`Response data length: ${json.data.length}`);
        // console.log(`Response data length: ${JSON.stringify(json.data)}`);
        return json.data;
    }).catch(err => {
        console.log(`Error during getBotExceptionsByEnv ${err.message}`);
        throw new Error("Error during getExceptionsByEnv");
    })
}


export function deleteItemsFromDeploymentConfig(deletedItems,env,setDeployStatus){


    let url = `${process.env.REACT_APP_API_PREFIX}/deployment/deleteBotExecutionConfig`;

    let deploymentProfile = {
        ExecutionProfile : {
            tenantId: getLoggedInUserTenantID(),
            environment:env,
            BotAgentLinkList: deletedItems
        }
        
        
    }
  

    return apiPost(url,deploymentProfile).then(res => {
        if(res.ok){
            // setAgentsChangedTrigger(true);
            setDeployStatus("Successfully removed Items from the Deployment Profile")
            setTimeout(() => {
                setDeployStatus("");
            },3000);
            return res.json()

        }else{
            console.log("Response is not ok during apiPost deletItems from Deployment config. thowing exception")
            throw new Error("Response is not ok during apiPost deleteItems From Deployment Config.")
        }
    })
    .then((json)=>{
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    .catch(err => {
        console.log(`Error during deployBots ${err.message}`)
        throw new Error("Server error during deleteItems From Deployment Config");
    })

}


export function promoteBotsFromEnv(sourceEnv,targetEnv,afterBotsArePromoted){

    let url = `${process.env.REACT_APP_API_PREFIX}/deployment/promoteBotExecutionConfigsByTenantIdAndEnvironment`;
    let data = {
        tenantId: getLoggedInUserTenantID(),
        sourceEnvironment: sourceEnv,
        targetEnvironment: targetEnv
    }

    return apiPost(url,data).then(res => {
        if(res.ok){
            // // setAgentsChangedTrigger(true);
            // setDeployStatus("Successfully Promoted Bots to " + targetEnv)
            // setTimeout(() => {
            //     setDeployStatus("");
            // },3000);
            afterBotsArePromoted();
            return res.json()

        }else{
            console.log("Response is not ok during apiPost promoteBotsFromEnv from Deployment config. thowing exception")
            throw new Error("Response is not ok during apiPost promoteBotsFromEnv From Deployment Config.")
        }
    })
    .then((json)=>{
        console.log(`json result ${json.result}`);
        console.log(`json message ${json.message}`);
        console.log(`json data ${JSON.stringify(json.data)}`);
        return json.data;
    })
    .catch(err => {
        console.log(`Error during promoteBotsFromEnv ${err.message}`)
        throw new Error("Server error during promoteBotsFromEnv");
    }) 

}


export function getBotLogSummary(){
    let url = `${process.env.REACT_APP_API_PREFIX}/botlog/getBotExecutionSummariesByTenantId/${getLoggedInUserTenantID()}`;
    return apiGet(url);
/*
    let botlog = {
        data:[
            {
                botName:"Dummy Test",
                description:"This is description for Dummy Test.",
                status:"OK",
                lastRun:"12-01-2022",
                startTime:"12-01-2022 1:00:00",
                endTime:"12-01-2022 1:15:00"
            },
            {
                botName:"Order Fulfilment",
                description:"This is description for Dummy Test.",
                status:"FAILED",
                lastRun:"12-01-2022",
                startTime:"12-01-2022 1:00:00",
                endTime:"12-01-2022 1:15:00"
            },
            {
                botName:"OnBoarding",
                description:"This is description for Dummy Test.",
                status:"OK",
                lastRun:"12-01-2022",
                startTime:"12-01-2022 1:00:00",
                endTime:"12-01-2022 1:15:00"
            },
            {
                botName:"Order Transportation",
                description:"This is description for Dummy Test.",
                status:"FAILED",
                lastRun:"12-01-2022",
                startTime:"12-01-2022 1:00:00",
                endTime:"12-01-2022 1:15:00"
            },
            {
                botName:"Daily Stock Report ",
                description:"This is description for Dummy Test.",
                status:"OK",
                lastRun:"12-01-2022",
                startTime:"12-01-2022 1:00:00",
                endTime:"12-01-2022 1:15:00"
            },
            {
                botName:"Daily Weather Report",
                description:"This is description for Dummy Test.",
                status:"OK",
                lastRun:"12-01-2022",
                startTime:"12-01-2022 1:00:00",
                endTime:"12-01-2022 1:15:00"
            },
        ]
    }

    return new Promise((resolve,reject)=>{
        resolve(botlog);
    });*/
}


export function getBotLogDetail(requestID){
    let url=`${process.env.REACT_APP_API_PREFIX}/botlog/getBotLogByTenantIdAndRequestId/tenant/${getLoggedInUserTenantID()}/request/${requestID}`;

    return apiGet(url);
}



